import { TinyMCE, Editor } from 'tinymce';
import { ajaxSpin, errorToast } from '../../Utils/utils';

declare let tinymce:TinyMCE;

export function editing(element:Element, allowed:Array<string>){
    const isAllowed = allowed.includes(element.id.toLowerCase());
    if (!isAllowed){
        const id = allowed[0];
        return $(element).parents("#" + id).length == 1;
    } else {
        return true;
    }
}

export function decodeMML(input:string):string {
    return input.replaceAll("«", "<").replaceAll("»", ">").replaceAll("¨", '"').replaceAll("§", "&")
}

export function encodeMML(input:string):string {
    return input.replaceAll("<", "«").replaceAll(">", "»").replaceAll('"', "¨")
}

export function getPoints(modal:JQuery){
    const points = Number(modal.find(".left-input").val().toString().replace(",","."));
    return points;
}

export function transformLength(lengthInPx:string){
    const length = Number(lengthInPx.toString().replace("px", ""))
    return length;
}

export function getData(node:Element){
    const data = JSON.parse(node.getAttribute('data-json').replace( /(['])/g, '"'))
    return data;
}

export function getDataFromJson(data){
    return JSON.parse(data.replace( /(['])/g, '"'))
}

export function generateRandomId(ids:Array<number>, max=200){
    let id = getRandomInt(1, max);
    while (ids.includes(id)){
        id = getRandomInt(1, max);
    }
    return id;
}

export function pointsValid(points:string|number):boolean{
    if (points === '' || points <= 0 || Number(points) != points){
        return false;
    } else {
        return true;
    }
}

export function setWindowNode(editor:Editor){
    const node = editor.selection.getNode();
    window["node"] = node;
    return node;
}

export function toJsonHtml(data:Object){
    return JSON.stringify(data).replace( /(["])/g, "'");
}

export function selectNode(editor:Editor){
    tinymce.activeEditor.execCommand('mceSelectNode', false, editor.selection.getNode() );
}

export function insertToEditor(html:string, editor:Editor = undefined){
    if (editor == undefined){
        editor = tinymce.get("task-editor");
    }

    if (window["node"]){
        editor.execCommand('mceSelectNode', false, window["node"] );
        // window["node"].remove();
        // editor.execCommand('mceReplaceContent', false, html);
        editor.insertContent(html, {format: 'raw'});
    } else {
        editor.insertContent(html, {format: 'raw'});
    }
    window["node"] = false;
}

export const mmlToSvg = function (formula:string) {
    const wrapper = MathJax.mathml2svg(`${formula}`, {em: 10, ex: 5,display: true})
    const output = { svg: "", img: "" }
    const mjOut = wrapper.getElementsByTagName("svg")[0]
    // mjOut.setAttribute("xmlns", "http://www.w3.org/2000/svg")
    output.svg = mjOut.outerHTML
    const svg = 'data:image/svg+xml;base64,' + window.btoa(unescape(encodeURIComponent(output.svg)));
    return svg // here we got what we want!
}

export function createStdModal(id:string, content=''){
    let html = '<div class="p-modal-container" id="' + id + '">';
    html += '<div class="p-modal-bg p-no-bg"></div>';
    html += '<div class="p-modal">'
    html += '<div class="p-inmodal p-modal-editor" style="width: 93%;height: 93%; resize: both;">';
    html += content;
    html += '</div></div></div>';
    return html;
}

export function displayErrors(errors){
    errors.forEach((error:string) => {
        errorToast(error, "Fehler", 9500, true);
    })
}

export function initEditor(selector:string, text:string){
    return {
        selector: selector,
        height: 250,
        menubar: false,
        language: 'de',
        skin: (localStorage.getItem('theme') == 'dark') ? "oxide-dark" : '',
        content_css: (localStorage.getItem('theme') == 'dark') ? "dark" : '',
        external_plugins: { tiny_mce_wiris: 'https://www.wiris.net/demo/plugins/tiny_mce/plugin.js' },
        menu: {
            edit: { title: "Bearbeiten", items: 'undo redo | cut copy paste | selectall | searchreplace' },
            format: { title: "Format", items: 'bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align lineheight | forecolor backcolor | removeformat' },
        },
        plugins: 'charmap code noneditable lists advlist table fullscreen textcolor hr codesample emoticons standard-inputs', // autosave, template vlt interessant
        contextmenu: 'drawit insert-image',
        toolar_mode: 'sliding',
        toolbar1: 'bold italic underline forecolor | bullist numlist table | tiny_mce_wiris_formulaEditor latex insert-image drawit |  undo ',
        setup: function(editor:Editor){
            editor.on("init", function(){
                if (text != '' && text !== undefined){
                    editor.setContent(text);
                }
            })
        }
    }
}

export function getTaskId(){
    return '||TASK||';
}

export function doesEditorExist(id:string){
    const instance = tinymce.get(id);
    return typeof(instance.contentDocument) !== undefined;
    // return instance !== null;
}

export function waitFor(condition, callback, data){
    if ( !condition()){
        window.setTimeout(waitFor.bind(null, condition, callback), 100);
    } else {
        callback(data);
    }
}

// Hier Object -> dataObject
export function b64ToImg(data:Object, editor:Editor, b64:string, callback:Function, btn:boolean|HTMLElement=false){
    const config = {
        url: '/upload-b64',
        async:false,
        data: {
            base64: b64,
        },
        success: function(output){
            callback(data, editor, output.path);
        },
        error: function(error){
            console.log(error);
            errorToast("Konnte nicht gespeichert werden");
        }
    }
    ajaxSpin(config);
}

export function getRandomInt(min:number, max:number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
  }
